import { createSlice } from "@reduxjs/toolkit"

const pageContentSlice = createSlice({
    name: "pageContent",
    initialState: {
        pageContents: [],
        isFetching: false,
        error: null
    },
    reducers: {
        pageContentStart: (state) => {
            state.isFetching = true
        },
        pageContentFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        getPageContentsSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.pageContents = action.payload
        },
        deletePageContentSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.pageContents.splice(
                state.pageContents.findIndex((item) => item._id === action.payload),
                1
            )
        },
        updatePageContentSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.pageContents[state.pageContents.findIndex((item) => item._id === action.payload.id)] = action.payload.pageContent
        },
        createPageContentSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.pageContents.push(action.payload)
        }
    }
})

export const {
    pageContentStart,
    pageContentFailure,
    getPageContentsSuccess,
    deletePageContentSuccess,
    updatePageContentSuccess,
    createPageContentSuccess } = pageContentSlice.actions
    
export default pageContentSlice.reducer
